var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVickyfineartDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-083a5004-7764-4e89-a8cd-513ba45e7e25",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.23 86.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.31,56.83v23.52c0,1.18-.78,1.96-1.96,1.96H5.88c-1.18,0-1.96-.78-1.96-1.96v-23.52H0v23.52c0,3.33,2.55,5.88,5.88,5.88H80.35c3.33,0,5.88-2.55,5.88-5.88v-23.52h-3.92Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "64.09 46.45 61.34 43.7 45.08 59.97 45.08 0 41.16 0 41.16 59.97 24.89 43.7 22.15 46.45 43.12 67.42 64.09 46.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVickyfineartDownload);
export default __webpack_public_path__ + "static/media/vicky fineart - download.a1c71e24409fb8605c227fe9ecce1a1f.svg";
export { ForwardRef as ReactComponent };